export default "__VITE_ASSET__891fa494__"